import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FiMatTabGroupBookmarkLayoutComponent } from './fi-mat-tab-group-bookmark-layout.component';
import { MatTabsModule } from '@angular/material/tabs';
import { FiMatTabBookmarkLayoutComponent } from '@fi-shared/fi-mat-card-bookmark-layout/fi-mat-tab-bookmark-layout.component';

@NgModule({
    imports: [CommonModule, MatTabsModule],
    declarations: [FiMatTabGroupBookmarkLayoutComponent, FiMatTabBookmarkLayoutComponent],
    exports: [FiMatTabGroupBookmarkLayoutComponent, FiMatTabBookmarkLayoutComponent],
})
export class FiMatTabGroupBookmarkLayoutModule {}
